import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import {
  AmsPartsUsedProvider,
  ClientEstateProvider,
  GasCopReportProvider,
  VisitsClientProvider,
  VisitsGeneralProvider,
  VisitTapsProvider,
  VisitWashersProvider
} from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const VisitsGeneral = Loader(lazy(() => import('../../content/pages/Reports/VisitsGeneral')));
const ClientEstate = Loader(lazy(() => import('../../content/pages/Reports/ClientEstate')));
const VisitsClient = Loader(lazy(() => import('../../content/pages/Reports/VisitsClient')));
const AmsPartsUsed = Loader(lazy(() => import('../../content/pages/Reports/AmsPartsUsed')));
const VisitTapsReport = Loader(lazy(() => import('../../content/pages/Reports/VisitTapsReport')));
const VisitWashersReport = Loader(lazy(() => import('../../content/pages/Reports/VisitWashersReport')));
const GasCopReport = Loader(lazy(() => import('../../content/pages/Reports/GasCopReport')));

type CustomRouteObject = RouteObject & {
  children?: CustomRouteObject[];
};

export const createReportRoutes = (): CustomRouteObject => ({
  path: 'reports',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['reportsVisitsGenViewAll']} should404>
          <Navigate to="/reports/visits-general" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'visits-general',
      element: (
        <PermissionsGuard allowedPermissions={['reportsVisitsGenViewAll']} should404>
          <VisitsGeneralProvider>
            <VisitsGeneral />
          </VisitsGeneralProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'client-estate',
      element: (
        <PermissionsGuard allowedPermissions={['reportsClientEstateViewAll']} should404>
          <ClientEstateProvider>
            <ClientEstate />
          </ClientEstateProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'visits-client',
      element: (
        <PermissionsGuard allowedPermissions={['reportsVisitsClientViewAll']} should404>
          <VisitsClientProvider>
            <VisitsClient />
          </VisitsClientProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `ams-parts`,
      element: (
        <PermissionsGuard allowedPermissions={['reportsAmsPartsViewAll']} should404>
          <AmsPartsUsedProvider>
            <AmsPartsUsed />
          </AmsPartsUsedProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `visit-taps`,
      element: (
        <PermissionsGuard allowedPermissions={['reportsWastageViewAll']} should404>
          <VisitTapsProvider>
            <VisitTapsReport />
          </VisitTapsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `visit-washers`,
      element: (
        <PermissionsGuard allowedPermissions={['reportsWastageViewAll']} should404>
          <VisitWashersProvider>
            <VisitWashersReport />
          </VisitWashersProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `gas-cop`,
      element: (
        <PermissionsGuard allowedPermissions={['reportsGasCopViewAll']} should404>
          <GasCopReportProvider>
            <GasCopReport />
          </GasCopReportProvider>
        </PermissionsGuard>
      )
    }
  ]
});
